import { render, staticRenderFns } from "./m-manage-list.vue?vue&type=template&id=7f1ef274&scoped=true"
import script from "./m-manage-list.vue?vue&type=script&lang=js"
export * from "./m-manage-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1ef274",
  null
  
)

export default component.exports